var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"welcome",staticClass:"welcome_login"},[(_vm.loginAnimation)?_c('img',{attrs:{"src":_vm.$UIConfig.loginSucGif,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }